/**
 * FRONT-1991 review F14/R10: whether the transition from `previous` to
 * `next` `operator-panel-store` request should close a full-screen modal
 * sitting underneath the desktop operator panel. Pure so it has its own
 * test, independent of the effect that calls it in `inbox-chat-modal.tsx`
 * and `build-window.tsx` — both watch the SAME store for the SAME
 * reason (CLAUDE.md's "modal viewers are mutually exclusive").
 *
 * Closes whenever `next` is a genuinely DIFFERENT, non-null request — not
 * only the null -> set transition (F14), but also an already-set request
 * being replaced by a different one (R10: a second, later request arriving
 * — e.g. a future chat-card button — while the panel is already up must
 * still close the modal underneath it; comparing only "was there no
 * request before" left the modal stacked in that case). The bug F14
 * replaced compared only the CURRENT value (`if (operatorPanelRequest)
 * onClose()`), which also fires on the very first render whenever a
 * request already happens to be set — making it impossible to open the
 * modal at all while the desktop panel is up. Two transitions must NOT
 * close: the same request object seen again (no real change, whether at
 * mount or later), and a request clearing (set -> null). Mounting fresh
 * while a request is already set is handled the same way: the caller seeds
 * its "previous" ref with the CURRENT value at mount
 * (`useRef(operatorPanelRequest)`, not `useRef(null)`), so the first effect
 * run compares the request against itself, never against `null`.
 */
export function shouldCloseForNewOperatorPanelRequest(previous: unknown, next: unknown): boolean {
  return next !== null && next !== previous;
}
